import YoutubePlayer from 'yt-player';


let ytVideoPopup = () => {

    let module = {},
        popup,
        popupClose,
        popupBody,
        body,
        page,
        main,
        ytVideo,
        createVideoPopup = (videoId) => {
            if (!popup.length) {
                return;
            }

            popup.show();


            setTimeout(function() {
                body.addClass('overflow-hidden');
                popup.addClass('active');

				if (!window.YT) {
					$("body").append('<div id="x-player" style="display:none"></div>');
					new YoutubePlayer("#x-player");
					$("#x-player").remove();
				}

                var checkReady = setInterval(function() {
					//console.log("init yt");
					if (!window.YT) { return; }
					clearInterval(checkReady);
					setTimeout(function() {
						createYtVideo(videoId);
						//console.log("create "+videoId);
					}, 500);
				}, 500);

            }, 50);
        },
        createYtVideo = (videoId) => {
            if (!popupBody.length) {
                return;
            }
            popupBody.each(function () {

				if (!$(this).find('#video-' + videoId).length) {
					$(this).append('<div id="video-' + videoId + '"></div>');
				}
				//console.log("init2");
				window.ytVideo = new YoutubePlayer('#video-' + videoId, {
					controls: 1,
					//width: "100%",
					//height: "100%",
					info: 0,
					related: 0,
					annotations: 0,
					captions: 0,
					modestBranding: 1,
					loop: 1,
					showinfo:0,
					playerVars: {
						rel: 0,
						showinfo: 0,
						ecver: 2
					}
				});

				window.ytVideo.load(videoId);

				const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

				if (iOS) {
					//window.ytVideo.mute();
				}


				if (! iOS) {
//					window.ytVideo.mute();
					window.ytVideo.play();
				}

				window.ytVideo.on('ended', () => {
					window.ytVideo.play();
				});

				// 2021-01-27 - close video on back button
				window.location.hash = 'overlay-video';
				window.addEventListener('hashchange', function() {
					if (window.location.hash != '#overlay-video' && popup.hasClass('active')) {
						popupClose.trigger("click");
					}
				}, false);

				return ytVideo;



            });
        },
        destroyYtVideo = () => {
            //ytVideo.stopVideo();
			if (typeof window.ytVideo !== 'undefined') {
				window.ytVideo.destroy();
			}
        },
        onPlayButtonClick = () => {
            // if 360 video on iOS, redirect to youtube
            const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

            $('[data-yt-video-popup-id]').on('click', function (event) {
                event.preventDefault();
                var $this = $(this);
                var videoId = $this.attr('data-yt-video-popup-id');
                if(!videoId) {
                    return;
                }

                if (iOS && $(this).hasClass('video-360')) {
                    window.location = 'https://www.youtube.com/watch?v='+ videoId +'&autoplay=1';
                    // window.location = 'youtube://'+ videoId;
                    return;
                }

                createVideoPopup(videoId);
            });
        },
        onCloseButtonClick = () => {
            if (!popupClose.length) {
                return;
            }
            popupClose.on('click', function () {
                body.removeClass('overflow-hidden');
                destroyYtVideo();
                popup.removeClass('active');

                setTimeout(function() {
                    popup.hide();
					//window.location.hash = '';
                }, 200);
            });
        },
        init = () => {
            popup = $('.yt-video-popup');
            popupClose = $('.yt-video-popup-close');
            popupBody = $('.yt-video-popup-body');
			popupBody.removeClass("multivideo");
            body = $('html,body');
            onPlayButtonClick();
            onCloseButtonClick();
            //console.log('yt-video-popup');

        };

    module.init = init;
	module.exports = {
	  run: function (videoId) {
		  init();
		  createVideoPopup(videoId);
	  }
	};
    return module;

};
window.ytVideoPopup = ytVideoPopup();
export default ytVideoPopup();
